import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";
import { Sow } from "./@types";

const fetchSOW = async (sowID: string, templateType: "admin" | "operative") => {
  const sow = await apiInputService.get(`/sow/sow/${sowID}`, {
    params: { templateType },
  });

  const { data } = sow;

  return data;
};

export const useSOWQuery = (
  sowID: string,
  templateType: "admin" | "operative",
  options?: any
) => {

  return useQuery<Sow>(["sow", sowID], () => fetchSOW(sowID, templateType), {
    staleTime: Infinity,
    ...options,
  });
};
